// extracted by mini-css-extract-plugin
module.exports = {"main":"Photoshoot_main__fbnwP","header":"Photoshoot_header__1Ygag"};